import { createActions } from 'redux-actions';
export const nodeWidgetCustomizationActions = createActions({}, 'NODE_WIDGET_CUSTOMIZATION_ADD_LOCALIZATION', 'NODE_WIDGET_CUSTOMIZATION_REMOVE_LOCALIZATION', 'NODE_WIDGET_CUSTOMIZATION_RESET_LOCALIZATION', 'NODE_WIDGET_CUSTOMIZATION_LOAD_PAYLOAD');
